import type { DatasetGpsEditorProps } from "./dataset-gps-editor.type";
import type { DatasetGps } from "@/entities/dataset";

import Coordinates from "@/components/Form/Coordinates";
import { DATASET_TYPE } from "@/entities/dataset";
import { useDatasetsMutatorSync } from "@/modules/datasets/datasets-mutator";

const datasetType = DATASET_TYPE.GPS;

const DatasetGpsEditor = ({
  disabled = false,
  dataset,
  template,
}: DatasetGpsEditorProps) => {
  const { addMutatorItem } = useDatasetsMutatorSync();
  const coordinate = dataset?.data;

  /**
   * Attempts to update the data
   *
   * @param {obj} location The location of the map interintervention.
   * @return {void}
   */
  const handleChange = (location: { lat: number; lng: number }) => {
    if (dataset) {
      const variables: Partial<DatasetGps> = {
        data: `${location?.lat ?? ""},${location?.lng ?? ""}`,
      };
      addMutatorItem({
        mutationType: "update",
        datasetType,
        datasetId: dataset.id,
        variables,
      });
    } else {
      const variables: Partial<DatasetGps> = {
        name: template.name ?? "",
        type: datasetType,
        data: `${location?.lat ?? ""},${location?.lng ?? ""}`,
        layout_index: template.layout_index,
      };
      addMutatorItem({
        mutationType: "create",
        datasetType,
        variables,
      });
    }
  };

  return (
    <Coordinates
      key={`id-${coordinate}`}
      mapId={`dataset_gps_${dataset?.id}`}
      onCoordinateChange={(lat: number, lng: number) => {
        handleChange({ lat, lng });
      }}
      value={coordinate}
      disabled={disabled}
    />
  );
};

export default DatasetGpsEditor;
